import { CapoPlugin } from "/home/vsts/work/1/s/web/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];